

export type Tabs = "lead" | "call" | "activity" | "sales" | "reports";


export interface TabItem {
    key: string;
    label: string;
    icon: string;
  }
  export interface MainTabItem {
    key: Tabs;
    label: string;
    icon: any; // for FontAwesome icons
  }  

export interface IDashboardTabs {
  handleTabOnchange: (tab: Tabs) => void;
  selectedTab: Tabs;
  totalLeadCount: number;
  totalCallCount: number;
  totalActivityCount: number;
  totalSalesCount: number;
  fromDate?: string;
  toDate?: string;
  onOpenCallLogs: () => void; // ADD THIS LINE
}


export interface IDashboardHeader {
  fromDate: string;
  toDate: string; // Add this line
  handleFilteronChange: (date: string) => void;
  selectFilterUser: (value: string, tab: string) => void;
  selectFilterDate: (e: React.ChangeEvent<HTMLInputElement>) => void;
  isCustomDate: boolean;
  customFromDate?: string; // 🆕 NEW: Custom date range values
  customToDate?: string; // 🆕 NEW: Custom date range values
  handleRefresh: () => Promise<void>; // 🆕 NEW: Refresh function
  onListSelectionChange?: (selectedListIds: string[]) => void; // 🆕 NEW: List filter callback
}

export interface DashboardComponent {
  id: string;
  name: string;
  enabled: boolean;
  category: string;
}

export interface DashboardVisibilityConfig {
  charts: {
    leadsBySource: boolean;
    leadsByLabel: boolean;
    salesFunnel: boolean;
    taskStatus: boolean;
    callLeaderboard: boolean;
    areaChart: boolean;
    userPerformance: boolean;
    leadAssignment: boolean;
    salesTarget: boolean;
    customFields: boolean;
    callLogs: boolean;
    userSync: boolean;
  };
  metrics: {
    secondaryMetrics: boolean;
    tabSpecificMetrics: boolean;
  };
  activities: {
    activityList: boolean;
  };
  reports: {
    callLeaderboard: boolean;
    callLogs: boolean;
    userPerformance: boolean;
    leadAssignment: boolean;
    salesFunnel: boolean;
    activitySummary: boolean;
    leadSource: boolean;
    leadByLabels: boolean;
    salesTarget: boolean;
    taskStatus: boolean;
    customFields: boolean;
    quotationStatus: boolean;
    userSyncStatus: boolean;
    trends: boolean;
  };
}

export const DEFAULT_VISIBILITY_CONFIG: DashboardVisibilityConfig = {
  charts: {
    leadsBySource: true,
    leadsByLabel: true,
    salesFunnel: true,
    taskStatus: true,
    callLeaderboard: true,
    areaChart: true,
    userPerformance: true,
    leadAssignment: true,
    salesTarget: true,
    customFields: true,
    callLogs: true,
    userSync: true,
  },
  metrics: {
    secondaryMetrics: true,
    tabSpecificMetrics: true,
  },
  activities: {
    activityList: true,
  },
  reports: {
    callLeaderboard: false,
    callLogs: false,
    userPerformance: false,
    leadAssignment: false,
    salesFunnel: false,
    activitySummary: false,
    leadSource: false,
    leadByLabels: false,
    salesTarget: false,
    taskStatus: false,
    customFields: false,
    quotationStatus: false,
    userSyncStatus: false,
    trends: true, // ✅ Default enabled - first tab
  },
};
